(() => {
  const overlay = document.getElementById('search-overlay');
  const trigger = document.querySelector('.header-search-trigger');
  if (!overlay || !trigger) return;

  const closeButton = overlay.querySelector('.search-overlay__close');
  const input = overlay.querySelector('#PredictiveSearchInput');
  const results = overlay.querySelector('[data-predictive-search-results]');
  const status = overlay.querySelector('.search-overlay__status');
  const allLink = overlay.querySelector('.search-overlay__all');
  let timer;
  let controller;

  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));

  const openSearch = () => {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('search-open');
    window.setTimeout(() => input.focus(), 80);
  };

  const closeSearch = () => {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('search-open');
    trigger.focus();
  };

  const renderProducts = products => {
    if (!products.length) {
      results.innerHTML = '';
      status.textContent = 'No matching watches found.';
      return;
    }
    status.textContent = `${products.length} matching ${products.length === 1 ? 'watch' : 'watches'}`;
    results.innerHTML = products.map(product => {
      const image = product.image ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : '';
      return `<a class="predictive-search-item" href="${escapeHtml(product.url)}">
        <span class="predictive-search-item__image">${image}</span>
        <span><p class="predictive-search-item__vendor">${escapeHtml(product.vendor || 'Vintage watch')}</p><p class="predictive-search-item__title">${escapeHtml(product.title)}</p><p class="predictive-search-item__price">${escapeHtml(product.price || '')}</p></span>
      </a>`;
    }).join('');
  };

  const search = async query => {
    const cleanQuery = query.trim();
    allLink.href = `/search?type=product&q=${encodeURIComponent(cleanQuery)}`;
    if (cleanQuery.length < 2) {
      results.innerHTML = '';
      status.textContent = 'Type at least two characters to search.';
      return;
    }
    if (controller) controller.abort();
    controller = new AbortController();
    status.textContent = 'Searching…';
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(cleanQuery)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Search request failed');
      const data = await response.json();
      renderProducts(data?.resources?.results?.products || []);
    } catch (error) {
      if (error.name === 'AbortError') return;
      results.innerHTML = '';
      status.textContent = 'Search is temporarily unavailable. Press Enter for full results.';
    }
  };

  trigger.addEventListener('click', openSearch);
  closeButton.addEventListener('click', closeSearch);
  overlay.addEventListener('click', event => { if (event.target === overlay) closeSearch(); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && overlay.classList.contains('open')) closeSearch();
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') { event.preventDefault(); openSearch(); }
  });
  input.addEventListener('input', event => {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => search(event.target.value), 220);
  });
})();
